import React, { ReactNode } from 'react';

import { Diary } from '../../../../type/recipe';
import useScrollSnap from '../../../../utils/hook/useScrollSnap';

const _DiaryShortsVerticalPhotoWrapper = ({
  diaries,
  toggleViewMode,
  modalRef,
  loadNextPage,
  render,
}: {
  diaries: Diary[];
  toggleViewMode: () => void;
  modalRef: React.MutableRefObject<HTMLDivElement | null>;
  loadNextPage: () => void;
  render: (diary: Diary, index: number) => ReactNode;
}) => {
  // 스크롤을 멈췄을때 70% 이상 스크롤 했으면 다음 페이지 불러오기
  const onChangeScrollRatio = (scrollRatio: number) => {
    scrollRatio >= 0.7 && loadNextPage();
  };

  useScrollSnap({
    ref: modalRef,
    targetArray: diaries,
    type: 'VERTICAL',
    onChangeScrollRatio,
  });

  return <div onClick={toggleViewMode}>{diaries.map(render)}</div>;
};

export default _DiaryShortsVerticalPhotoWrapper;
